/**
 * Permisos de Talent Acquisition — GovernancePanel (modelo Partnerships) con
 * Ignacio Bresso como admin fijo. Desde el 28/09/2026 es una sección del Admin
 * de TA (TaAdminTab); las reglas de cálculo y las fotos semanales tienen la suya.
 */
import { GovernancePanel } from '@/components/governance/GovernancePanel';
import { useSaveTaGovernance, useTaCommunityPicker, useTaGovernance } from '@/hooks/useTalentAcquisition';

export function TaGovernanceTab() {
  const { data: governance, isLoading, isError } = useTaGovernance();
  const { data: members = [], isLoading: membersLoading } = useTaCommunityPicker();
  const save = useSaveTaGovernance();
  return (
    <GovernancePanel
      namespace="talent_acquisition.governance"
      governance={governance}
      isLoading={isLoading}
      isError={isError}
      members={members}
      membersLoading={membersLoading}
      onSave={(payload, onSuccess) => save.mutate(payload, { onSuccess })}
      saving={save.isPending}
    />
  );
}
